/* eslint-disable @typescript-eslint/no-inferrable-types */
import { VisibilityState } from './visibilityReducer';

// This controls which blades are visible and which blade has focus
export const updateDisplayAndFocus = (completedBlade: string, bladeList: VisibilityState) => {
  const bladeNames = Object.keys(bladeList);
  const bladeIndex = bladeNames.indexOf(completedBlade);
  const nextBlades = bladeNames.slice(bladeIndex + 1);

  let displayImmediateBlade: boolean = false;
  let focusSet = false;
  // Remove focus from all blades
  bladeNames.forEach((blade: string) => {
    bladeList[blade].hasFocus = false;
  });

  nextBlades.forEach((blade: string) => {
    if (bladeList[blade].required) {
      // The first required blade
      // thats should be visible next
      if (!displayImmediateBlade) {
        bladeList[blade].display = true;
        displayImmediateBlade = true;
      }
    } else {
      // Hide blades that aren't required
      bladeList[blade].display = false;
    }
    // The first visible blade (after blade completed) should be focused
    if (bladeList[blade].display && !focusSet) {
      bladeList[blade].hasFocus = true;
      focusSet = true;
    }
  });
};

/**
 * Return whether a blade should display
 *
 * @param blade
 * @param visibility
 */
export const shouldBladeDisplay = (blade: string, visibility: VisibilityState): boolean => {
  if (typeof visibility === 'undefined') {
    return false;
  }
  if (typeof visibility[blade] === 'undefined') {
    return false;
  }
  return visibility[blade].display;
};
